// Placement formatting helpers – extracted from PlacementDetailsTableService

export const isValidDateString = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return false;
  const dateRegex = /^([A-Za-z]{3})\s(\d{1,2}),\s(\d{4})$/i;
  dateRegex.getMonthNumber = function(monthName) {
    const monthNames = {
      jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
      jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
    };
    return monthNames[monthName.toLowerCase()];
  };
  const matches = dateString.match(dateRegex);
  if (!matches) return false;
  const monthName = matches[1];
  const day = parseInt(matches[2], 10);
  const year = parseInt(matches[3], 10);
  const date = new Date(`${monthName} ${day}, ${year}`);
  return (
    date.getFullYear() === year &&
    date.getMonth() === dateRegex.getMonthNumber(monthName) &&
    date.getDate() === day
  );
};

export const converDateToYMDFormat = (dateString) => {
  if (dateString) {
    const dateParts = dateString.split(" ");
    const month = dateParts[0].toUpperCase();
    const day = dateParts[1].replace(",", "");
    const year = dateParts[2];
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const formattedDate = year + "-" + (months.indexOf(month) + 1).toString().padStart(2, "0") + "-" + day.padStart(2, "0");
    return formattedDate;
  } else {
    return dateString;
  }
};

export const getNumberWithTwoDigitsAfterDecimal = (number, isItAuthorizedAmount = false, currencyName = 'USD') => {
  if (isItAuthorizedAmount && (number === null || number === '' || number === undefined)) {
    return '';
  }
  let num = number;
  if (typeof number === 'string') {
    if (number === "") return '';
    num = Number(number);
    if (isNaN(num)) return '';
  }
  if (typeof num === 'number') {
    num = num.toLocaleString('en-US', {
      style: 'currency',
      currency: currencyName || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return num;
  }
  return '';
};

export const getPlannedCost = (value, index, isLocal, currency) => {
  let plannedCost = null;
  if (isLocal) {
    plannedCost = value?.planned_cost_local || value.plannedCostLocal;
  } else {
    plannedCost = value?.planned_cost || value.plannedCost;
  }
  return getNumberWithTwoDigitsAfterDecimal(plannedCost, false, currency);
};

export const getUnits = (value) => {
  if ((value.package_type !== 'Child' || value.parent_type === 'Package') &&
    value.package_type !== "DirectCreative" &&
    value.package_type !== "DirectLine" &&
    value.unit_amount) {
    return value.unit_amount.toLocaleString('en-US');
  } else {
    return '';
  }
};

export const getAdFee = (value, field) => {
  if ((value.package_type !== 'Child' || value.parent_type === 'Package') && value.package_type !== "DirectCreative" && value[field]) {
    return getNumberWithTwoDigitsAfterDecimal(value[field]);
  } else {
    return '';
  }
};

export const getRate = (value, isLocal = false, currency = 'USD') => {
  let field = isLocal && currency ? 'rate_local' : 'rate';
  if ((value.package_type !== 'Child' || value.parent_type === 'Package') &&
    value.package_type !== "DirectCreative" &&
    value.package_type !== "DirectLine" &&
    (value[field] || (value.rate == 0 && value.cost_method === "Flat"))) {
    return value[field]?.toLocaleString('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  return '';
};

export const getAdServerFee = (value) => {
  return value?.ad_server_fee?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const getAdVerificationFee = (value) => {
  return value?.ad_verification_fee?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const getDimensions = (value, index) => {
  if ((value.package_type !== 'Child' || value.parent_type === 'Package') && value.package_type !== "DirectCreative") {
    return value.dimensions;
  } else {
    return '';
  }
};

export const getStaticField = (index, field, state) => {
  return (
    <div className={`input-container`} key={index}>
      <label htmlFor={field.name + index}>
        {field.alias ? field.alias : field.name}
      </label>
      <input
        id={field.name + index}
        key={field.name + index}
        fieldtype="taxonomy"
        fieldid={field.id}
        fieldname={field.name}
        maxLength={field.character_limit}
        value={state.formData[field.name]}
        placeholder={field.name}
        disabled
      ></input>
    </div>
  );
};
